module.exports = __webpack_public_path__ + "media/svg/credit_card-53acd72f.svg";